import type { ModalSize } from '@ksyos/design-system';
import type { ReactElement, ReactNode } from 'react';
import { Box, Modal as DsModal } from '@ksyos/design-system';
import classnames from 'classnames';
import { cloneElement } from 'react';

interface IModalProps {
    actionButtons?: ReactElement<{ key: number }>[];
    automation?: string;
    children?: ReactNode;
    closeOnEsc?: boolean;
    closeOnOverlayClick?: boolean;
    isOpen: boolean;
    onClose: () => void;
    size: ModalSize;
    title?: string;
    titleIcon?: ReactElement;
}

export function Modal(props: IModalProps) {
    return (
        <DsModal
            className="automation-modal"
            closeOnEsc={props.closeOnEsc}
            closeOnOverlayClick={props.closeOnOverlayClick}
            isOpen={props.isOpen}
            onClose={props.onClose}
            size={props.size}
        >
            {props.title && (
                <DsModal.Header
                    className={classnames(
                        'automation-modal-title',
                        props.automation ? 'automation-' + props.automation : ''
                    )}
                >
                    <Box
                        alignItems="center"
                        display="flex"
                    >
                        {props.titleIcon}
                        {props.title}
                    </Box>
                </DsModal.Header>
            )}
            <DsModal.CloseButton />
            <DsModal.Body className="automation-modal-body">{props.children}</DsModal.Body>

            {props.actionButtons && (
                <DsModal.Footer className="automation-modal-footer">
                    {props.actionButtons && props.actionButtons.map((button, i) => cloneElement(button, { key: i }))}
                </DsModal.Footer>
            )}
        </DsModal>
    );
}
